import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { contactsActionTypes } from '../contacts-action-types';
import { getFormattedContactFields, IContactFormReturnTypes } from '../../../constants/add-contact/add-contact-form';
import { formikErrorHandler } from '../../../utils/formikUtils';
import * as React from 'react';
import { IContact, IContactsAction } from '../contacts-interfaces';
import { IContactsFilter } from '../../../components/contacts/ContactsFilter';
import { IPaginationData } from '../../../interfaces/funds';
import { GET } from '../../store-helper';

export const fetchContacts = async (searchParams: IContactsFilter): Promise<IPaginationData> => {
	try {

		return await GET({ pathname: `${BASE_URL.CONTACTS}/contacts`, params: searchParams });

	} catch (e) {
		console.log('fetchContacts:', e);
	}
};

export const fetchContactDetails = async (dispatch: React.Dispatch<IContactsAction> , id: string): Promise<void> => {
	try {
		dispatch({ type: contactsActionTypes.SET_CONTACT_DETAILS_LOADING, payload: true });

		const res = await GET({ pathname: `${BASE_URL.CONTACTS}/contacts/${id}` });

		dispatch({ type: contactsActionTypes.FETCH_CONTACT_DETAILS_DATA, payload: res?.data ?? {}});
	} catch (e) {
		dispatch({ type: contactsActionTypes.SET_CONTACT_DETAILS_LOADING, payload: false });
		console.log('fetchContacts:', e);
	}
};

export const addNewContact = async (
	dispatch: React.Dispatch<IContactsAction>,
	formik: any,
	onSuccess: () => void,
	onError: () => void,
	chosenContact: IContact
): Promise<void> => {
	if (!formik.isValid) return;
	try {
		dispatch({ type: contactsActionTypes.SET_ADD_CONTACT_LOADING, payload: true });
		const body: IContactFormReturnTypes = getFormattedContactFields(formik.values);
		console.log('body', body);
		if (chosenContact) {
			body.id = chosenContact?.id;
			delete body.profileUrl;
			await axios.put(`${BASE_URL.CONTACTS}/contacts`, body);
		} else {
			await axios.post(`${BASE_URL.CONTACTS}/contacts`, body);
		}
		// await fetchContacts(dispatch);
		onSuccess();
		dispatch({ type: contactsActionTypes.SET_ADD_CONTACT_LOADING, payload: false });
	} catch (e) {
		dispatch({ type: contactsActionTypes.SET_ADD_CONTACT_LOADING, payload: false });
		console.log('addNewContact:', e);
		if (e.response?.data?.General) {
			// dispatch({ type: merchantActionTypes.SET_GENERAL_ERROR, payload: e.response.data.General });
			onError();
		} else if (e.response.data) {
			formikErrorHandler({ formik, data: e.response?.data });
		}
	}
};

